import React from "react";
import { UserCheck, UserX, Clock, Share2 } from "lucide-react";

const AffiliatesTable = ({ affiliates = [], referralCode }) => {
  // Función para mostrar el icono según el estado
  const getStatusIcon = (status) => {
    switch (status?.toLowerCase()) {
      case "activo":
        return <UserCheck size={18} className="text-green-500" />;
      case "inactivo":
        return <UserX size={18} className="text-red-500" />;
      case "pendiente":
        return <Clock size={18} className="text-yellow-500" />;
      default:
        return <Clock size={18} className="text-gray-400" />;
    }
  };

  // Función para mostrar la clase de color según el estado
  const getStatusClass = (status) => {
    switch (status?.toLowerCase()) {
      case "activo":
        return "bg-green-500/20 text-green-400";
      case "inactivo":
        return "bg-red-500/20 text-red-400";
      case "pendiente":
        return "bg-yellow-500/20 text-yellow-400";
      default:
        return "bg-gray-500/20 text-gray-400";
    }
  };

  // Manejar la copia del código de referido
  const handleCopyReferralCode = () => {
    if (referralCode) {
      navigator.clipboard.writeText(referralCode);
      // Podrías añadir una notificación aquí
      alert("Código de referido copiado al portapapeles");
    }
  };

  return (
    <div className="bg-gray-800 rounded-lg p-6 shadow-lg">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-xl font-semibold text-white">
          Afiliados Recientes
        </h3>

        {referralCode && (
          <div className="flex items-center">
            <span className="text-gray-400 mr-2 hidden sm:inline">
              Tu código de referido:
            </span>
            <div className="flex items-center bg-gray-700 rounded px-3 py-1">
              <span className="text-white font-medium mr-2">
                {referralCode}
              </span>
              <button
                onClick={handleCopyReferralCode}
                className="text-blue-400 hover:text-blue-300 transition-colors"
                title="Copiar código"
              >
                <Share2 size={16} />
              </button>
            </div>
          </div>
        )}
      </div>

      {!affiliates || affiliates.length === 0 ? (
        <div className="text-center py-10 border border-dashed border-gray-700 rounded-lg bg-gray-800/50">
          <div className="mb-4">
            <UserX size={48} className="text-gray-500 mx-auto" />
          </div>
          <p className="text-gray-400 mb-2">
            Aún no tienes afiliados registrados con tu código.
          </p>
          <p className="text-gray-500 mb-4">
            Comparte tu código de referido para comenzar a crecer tu red.
          </p>

          {referralCode && (
            <button
              onClick={handleCopyReferralCode}
              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors inline-flex items-center"
            >
              <Share2 size={16} className="mr-2" />
              Copiar código de referido
            </button>
          )}
        </div>
      ) : (
        <>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="text-left text-gray-400 text-sm border-b border-gray-700">
                  <th className="pb-3 font-medium">Nombre</th>
                  <th className="pb-3 font-medium">Email</th>
                  <th className="pb-3 font-medium">Fecha de registro</th>
                  <th className="pb-3 font-medium">Tipo de cuenta</th>
                  <th className="pb-3 font-medium">Estado</th>
                </tr>
              </thead>

              <tbody>
                {affiliates.map((affiliate) => (
                  <tr
                    key={affiliate.id}
                    className="border-b border-gray-700 hover:bg-gray-700/30"
                  >
                    <td className="py-3 text-white">{affiliate.name}</td>
                    <td className="py-3 text-gray-300">{affiliate.email}</td>
                    <td className="py-3 text-gray-300">{affiliate.date}</td>
                    <td className="py-3 text-gray-300">
                      {affiliate.typeU || "No especificado"}
                    </td>
                    <td className="py-3">
                      <div className="flex items-center">
                        <span
                          className={`flex items-center px-2 py-1 rounded text-xs ${getStatusClass(
                            affiliate.status
                          )}`}
                        >
                          {getStatusIcon(affiliate.status)}
                          <span className="ml-1">{affiliate.status}</span>
                        </span>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Sección para ver todos los afiliados */}
          <div className="mt-4 flex justify-between items-center">
            <p className="text-gray-400 text-sm">
              <span className="font-semibold text-white">
                {affiliates.length}
              </span>{" "}
              afiliado(s) registrado(s)
            </p>
            {affiliates.length > 5 && (
              <button className="text-blue-400 hover:text-blue-300 text-sm font-medium">
                Ver todos los afiliados →
              </button>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default AffiliatesTable;
